export const ExaminerInitialValues = {
  name: "",
  email: "",
  contactNumber: null,
  designation: "",
  department: "",
};
